import * as React from 'react';
import { Plus, Edit, Medal, BadgeCheck } from 'lucide-react';
import { LoyaltyBadge, LoyaltyIndexPaths } from '../../LoyaltyIndex.type';

interface BadgesListProps {
  badges: LoyaltyBadge[];
  paths: LoyaltyIndexPaths;
  accountCode: string;
}

export function BadgesList({ badges, paths, accountCode }: BadgesListProps) {
  const activeBadges = badges.filter((badge) => badge.status === 'active').length;

  return (
    <article className="loyalty-card">
      <header className="loyalty-card__header">
        <div>
          <h2 className="loyalty-card__title">
            <Medal size={20} />
            Badges
          </h2>
          <p className="loyalty-card__description">
            {badges.length > 0
              ? `${activeBadges} de ${badges.length} badges estão ativos.`
              : 'Crie badges para recompensas visuais dos alunos.'}
          </p>
        </div>
        <a
          href={paths.newBadge}
          className="loyalty-button loyalty-button--primary loyalty-button--compact"
        >
          <Plus size={16} />
          Novo Badge
        </a>
      </header>
      <div className="loyalty-card__body loyalty-card__body--flush">
        <ul className="loyalty-list">
          {badges.map((badge) => (
            <li key={badge.id} className="loyalty-list__item">
              <div className="loyalty-list__identity">
                {badge.imageUrl ? (
                  <img
                    src={badge.imageUrl}
                    alt={badge.name}
                    className="loyalty-avatar"
                  />
                ) : (
                  <div className="loyalty-avatar loyalty-avatar--empty">
                    <Medal size={20} />
                  </div>
                )}
                <div className="loyalty-list__copy">
                  <div className="loyalty-list__title">{badge.name}</div>
                  <div className="loyalty-list__meta">{badge.code}</div>
                </div>
              </div>
              <div className="loyalty-list__actions">
                {badge.status === 'active' ? (
                  <span className="loyalty-badge loyalty-badge--success">
                    Ativo
                  </span>
                ) : (
                  <span className="loyalty-badge">Inativo</span>
                )}
                <a
                  href={`/${accountCode}/admin/loyalty/badges/${badge.id}/edit`}
                  className="loyalty-icon-button"
                  aria-label={`Editar badge ${badge.name}`}
                  title="Editar badge"
                >
                  <Edit size={16} />
                </a>
              </div>
            </li>
          ))}
          {badges.length === 0 && (
            <li className="loyalty-empty-state">
              <div className="loyalty-empty-state__icon">
                <BadgeCheck size={22} />
              </div>
              <p className="loyalty-empty-state__title">
                Nenhum badge cadastrado
              </p>
              <p className="loyalty-muted">
                Use badges para destacar conquistas recorrentes no app.
              </p>
              <a
                href={paths.newBadge}
                className="loyalty-button loyalty-button--secondary loyalty-button--compact"
              >
                <Plus size={16} />
                Criar primeiro badge
              </a>
            </li>
          )}
        </ul>
      </div>
    </article>
  );
}
